/* eslint-disable */
// AUTO-GENERATED - DO NOT EDIT

import SCHEMA_DATA from '@xviz/schema/dist/schema.json';
import PROTO_DATA from '@xviz/schema/dist/proto.v2.json';

export {SCHEMA_DATA, PROTO_DATA};
